import { IApplicationState } from '../../types/redux';
import { ISubmittedApplication } from '../../types';

export const selectSubmittedAnketaApplication = (state: IApplicationState): ISubmittedApplication | null =>
  state.calculator.submittedAnketaModal.application;
